// extracted by mini-css-extract-plugin
export default {"container":"CampaignDashboardPageContentContainer_container__xljwg"};